<template>
  <div class="pc-translate">
    <p class="icon" @click="changeTranslate">
      <span
        class="iconfont icon-jiantou_qiehuanxiangxia"
        :class="translate == 'cTe' ? 'active' : ''"
      ></span>
      <span
        class="iconfont icon-jiantou_qiehuanxiangshang"
        :class="translate == 'eTc' ? 'active' : ''"
      ></span>
    </p>
    <p class="title" @click="translateContent">
      {{ translate == "cTe" ? "中译英" : "英译中" }}
    </p>

  </div>
</template>

<script>
export default {
  data() {
    return {
      translate: "cTe",

    };
  },
  methods: {
    changeTranslate() {
      this.translate == "cTe"
        ? (this.translate = "eTc")
        : (this.translate = "cTe");
    },
    translateContent() {
      this.$emit("translateContent",this.translate);
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-translate {
  display: flex;
  position: relative;
  transform: translateX(90%);
  margin-bottom: 20px;
  p {
    .iconfont {
      cursor: pointer;
      color: $thirdTitle;
      font-size: 30px;
    }
    .icon-jiantou_qiehuanxiangxia {
      margin-right: -25px;
    }
    .active {
      color: $timeBtn;
    }
  }
  .title {
    cursor: pointer;
    width: 80px;
    height: 30px;
    line-height: 30px;
    background: $timeBtn;
    border-radius: 15px;
    text-align: center;
    color: $base-color;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/template/Translate.vue